var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowsChange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.74 40.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-10{fill:none;stroke:#505050;stroke-miterlimit:10;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrows_change") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Laag_2",
    "data-name": "Laag 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M0,13.71H9c2.28,0,3.59.66,4.58,2.33l7.54,12.21a11.24,11.24,0,0,0,10.11,5.46H35V38.5l11-7.79L35,23v4.68H31.18c-1.56,0-3.08-.49-4.59-2.71L19.05,12.48C16.37,8.12,13.64,6.71,9,6.71H0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M20,6.93c-2.37-3.16-5-4.22-9-4.22H0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M20,33.49c-2.37,3.15-5,4.22-9,4.22H0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M0,33.71H9c4.23,0,6.26-.47,8.37-3.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M13.7,24.25l-.22.67A5.12,5.12,0,0,1,9,27.71H0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M26.42,16c1.48-1.73,3-3.26,4.76-3.26H35V17.4L46,9.71,35,1.93V6.71H31.18a10.46,10.46,0,0,0-8.36,3.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M32,2.71H29.18A10.28,10.28,0,0,0,22,5.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M32,37.71H29.18A10.28,10.28,0,0,1,22,35.29"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsChange);
export default __webpack_public_path__ + "static/media/arrows-change.802edc375eec366c1ff468bff7b12670.svg";
export { ForwardRef as ReactComponent };